import styled from "styled-components";
import { Colors, Styles } from "../../core/brand/themes";

export const Card = styled.div({
    borderRadius: "3px",
    background: Colors.white(),
    ...Styles.shadow(),
});
